module.exports = __webpack_public_path__ + "img/ch-food-security.b09b205b.jpg";